import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Window, WindowHeader, WindowContent, Hourglass, Button, GroupBox, Checkbox } from 'react95';
import classNames from 'classnames';
import { get, isNil } from 'lodash-es';
import { substagesVisibleSelector } from '../../selectors/taskDetailSelectors';
import { setModalType, setSubstagesVisible } from '../../actions/taskDetailActions';
import { SUBSTAGE_FIELDS } from '../../global/Environment';
import './SubstagesTable.scss';
import { useCreateTaskSubstagesMutation, useDeleteTaskSubstageMutation, useGetTaskQuery } from '../../api/opsSystemApi';
import { useParams } from 'react-router-dom';

const SubstagesTable = () => {
  const dispatch = useDispatch();
  const { taskId } = useParams();

  const substagesVisible = useSelector(substagesVisibleSelector);

  const [createTaskSubstages] = useCreateTaskSubstagesMutation();
  const [deleteTaskSubstage] = useDeleteTaskSubstageMutation();

  const { data: task = {}, isLoading: isTaskLoading } = useGetTaskQuery(taskId);

  const regularSubstages = SUBSTAGE_FIELDS.filter((x) => !x.special);
  const specialUiSubstages = SUBSTAGE_FIELDS.filter((x) => x.special);
  const currentSpecialSubstages = specialUiSubstages.map((x) => x.name).filter((x) => get(task.substagesMap, x));

  return (
    <Window className={classNames('substages-table-window', { hidden: !substagesVisible })}>
      <div className='substages-table-window-inner'>
        <WindowHeader className='substages-table-header'>
          <div>
            <span>Substages</span>
            {isTaskLoading && <Hourglass size={24} />}
          </div>
          <Button
            primary
            square
            size='sm'
            variant='flat'
            onClick={() => dispatch(setSubstagesVisible(!substagesVisible))}>
            -
          </Button>
        </WindowHeader>
        <WindowContent className='substages-table-content'>
          <GroupBox label='Regular UI substages:' className='substages-table-content-group'>
            {regularSubstages.map((option) => {
              const substage = get(task.substagesMap, option.name);
              const isChecked = !isNil(substage);
              return (
                <Checkbox
                  key={option.name}
                  value={option.name}
                  label={option.label}
                  disabled={!task.user?.id || !!option.disabled}
                  checked={isChecked}
                  onChange={() =>
                    isChecked
                      ? deleteTaskSubstage({
                          taskSubstageId: substage.id
                        })
                      : createTaskSubstages({
                          taskId: task.id,
                          names: [option.name]
                        })
                  }
                />
              );
            })}
          </GroupBox>

          <GroupBox label='Special UI substages:' className='substages-table-content-group'>
            {specialUiSubstages.map((option) => {
              const substage = get(task.substagesMap, option.name);
              const isChecked = !isNil(substage);
              return (
                <Checkbox
                  key={option.name}
                  value={option.name}
                  label={option.label}
                  checked={isChecked}
                  onChange={() =>
                    isChecked
                      ? deleteTaskSubstage({
                          taskSubstageId: substage.id
                        })
                      : dispatch(setModalType(option.name))
                  }
                  disabled={
                    !task.user?.id ||
                    isTaskLoading ||
                    (currentSpecialSubstages.length && !currentSpecialSubstages.includes(option.name))
                  }
                />
              );
            })}
          </GroupBox>
        </WindowContent>
      </div>
    </Window>
  );
};

export default SubstagesTable;
